"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reducers = require("../reducers");

var _connectWithInputs = _interopRequireDefault(require("../util/connectWithInputs"));

/**
 * Creates a local store for redux-inputs unique to this component and its children
 * The caveat here is that if the component unmounts, the store is destroyed, just like component state
 */
var LocalInputs =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(LocalInputs, _React$Component);

  function LocalInputs(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LocalInputs);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LocalInputs).call(this, props));
    var inputsConfig = props.inputsConfig;
    _this._store = (0, _redux.createStore)((0, _redux.combineReducers)({
      inputs: (0, _reducers.createInputsReducer)(inputsConfig)
    }), (0, _redux.applyMiddleware)(_reduxThunk.default));
    _this._ConnectedInputs = (0, _connectWithInputs.default)(inputsConfig)()(function (_ref) {
      var reduxInputs = _ref.reduxInputs,
          children = _ref.children;
      return children(reduxInputs);
    });
    return _this;
  }

  (0, _createClass2.default)(LocalInputs, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var ConnectedInputs = this._ConnectedInputs; // Connects children component in propsMode so we don't have to set up a `Provider`

      return _react.default.createElement(ConnectedInputs, {
        store: this._store,
        children: children
      });
    }
  }]);
  return LocalInputs;
}(_react.default.Component);

exports.default = LocalInputs;
LocalInputs.propTypes = {
  inputsConfig: _propTypes.default.object.isRequired,
  children: _propTypes.default.func.isRequired // Callback with reduxInputs props

};


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/components/LocalInputs.js
// module id = 803
// module chunks = 0